<template>
	<div class="resources">
		<Nav />
		<span class="overlay" :class="{active: isMenuOpen}"></span>
		<div class="header header-standard">
			<HeaderNavBar back survey searchType="resources"/>
		</div><!-- header -->
		<div class="header-image lblue"></div><!-- header image -->
		<div class="content-wrap content-wrap-alt content-wrap-nav">
			<div class="has-split">
				<SectionTitle
					icon="ShipIcon"
					title="Your Results"
					colour="lblue"
				/>
				<img width="90" class="shi-logo" alt="The Seafarers Happiness Index" src="@/assets/shi-logo.png" />
			</div>
			<div class="section-gap">
				<div class="survey-graph">
					<div class="survey-graph-row top">
						<div class="graph-lines">
							<span class="line one"></span>
							<span class="line two"></span>
							<span class="line three"></span>
							<span class="line four"></span>
							<span class="line five"></span>
						</div>
						<div
                            v-for="score in graph.scores"
                            :key="score"
                            class="survey-graph-col"
                        >
							<span
                                class="graph-score"
                                :class="{
                                    'green': score >= 7,
                                    'orange': score >= 4 && score < 7,
                                    'red': score < 4
                                }"
                                :style="'bottom: calc(' + (score * 10) + '% - 13px);'"
                            >
                                {{ parseFloat(score) }}
                            </span>
						</div>
					</div>
					<div class="survey-graph-row end">
						<div
                            v-for="(date, index) in graph.dates"
                            :key="index"
                            class="survey-graph-col"
                        >
							<span class="survey-graph-date">{{ date.day }} <span>{{ date.month }}</span></span>
						</div>
					</div>
				</div>
			</div>

            <div v-for="(monthYearResults, monthYear) in results" :key="monthYear" class="section-gap">
                <span class="score-card-sub">{{ monthYear }}</span>
                <div class="card-row-wrap">
                    <ScoreCard
                        v-for="result in monthYearResults"
                        :key="result.uuid"
                        routeName="SurveyResult"
                        :id="result.uuid"
                        :score="parseFloat(result.score)"
                        :date="result.created_at | moment('MMMM YYYY')"
                    />
                </div><!-- port card wrap -->
            </div>

            <div class="section-gap card-wrap">
                <Card
                    routeName="SurveyTake"
                    class="card-block-sky-base card-block-full"
                    icon="SurveyIcon"
                    title="Take our Survey"
                    text="Tell us how you feel"
                />
            </div><!-- card wrap -->
		</div>
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Menu from '@/components/Menu.vue';
	import Card from '@/components/Card.vue';
	import SectionTitle from '@/components/SectionTitle.vue';
    import ScoreCard from '@/components/ScoreCard.vue';
    import SurveyService from '@/services/SurveyService';
	export default {
		name: 'SurveyResults',
		components: {
			Nav,
			HeaderNavBar,
			Menu,
			Card,
			SectionTitle,
			ScoreCard
		},
		data () {
	        return {
                graph: {
                    dates: [],
                    scores: []
                },
                results: []
	        };
	    },
	    methods: {
            getResults () {
                return SurveyService.getResults().then((response) => {
                    this.graph.dates = response.data.graph.dates;
                    this.graph.scores = response.data.graph.scores;
                    this.results = response.data.results;
                });
            }
	    },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        }
		},
		mounted () {
            this.getResults();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	@mixin max_width($breakpoint) {
	    @media only screen and (max-width: $breakpoint) { @content; }
	}
	.has-split {
		display: flex;
		justify-content: space-between;
		align-items: center;
		@include max_width(380px) {
			align-items: flex-start;
		}
		.shi-logo {
			margin-left: 15px;
			@include max_width(380px) {
				width: 85px;
			}
		}
	}
	.survey-graph {
		height: 210px;
		padding: 15px;
		padding-top: 25px;
		position: relative;
		background: $sky_light;
		border-radius: 12px;
		display: flex;
    	justify-content: space-between;
    	flex-direction: column;
    	.survey-graph-col {
    		display: flex;
    		flex-direction: column;
    		justify-content: flex-end;
    		width: 100%;
    		position: relative;
    		&:last-of-type {
    			.survey-graph-date {
    				opacity: 1;
    			}
    		}
    	}
    	.graph-score {
    		height: 28px;
    		width: 28px;
    		border-radius: 100%;
    		display: flex;
    		align-items: center;
    		justify-content: center;
    		text-align: center;
    		background: $green_base;
    		color: $white;
    		font-size: 10px;
			letter-spacing: -0.25px;
			line-height: 12px;
			text-transform: uppercase;
			font-weight: 500;
			position: absolute;
			transform: translateX(-50%);
			left: 50%;
			&.green {
				background: $green_base;
			}
			&.orange {
				background: $yellow_base;
			}
			&.red {
				background: $red_base;
			}
    	}
    	.survey-graph-row {
    		display: flex;
		    justify-content: space-between;
		    position: relative;
		    &.top {
		    	height: 100%;
		    }
		   	&.end {
		   		align-self: flex-end;
		   		width: 100%;
		   		margin-top: 15px;
		   	}
    	}
    	.survey-graph-date {
    		text-align: center;
    		color: $sky_dark;
			font-size: 10px;
			letter-spacing: 0.83px;
			line-height: 12px;
			text-transform: uppercase;
			opacity: 0.5;
			font-weight: 500;
    		span {
    			display: block;
    		}
    	}
    	.graph-lines {
    		position: absolute;
    		top: 0;
    		left: 0;
    		width: 100%;
    		height: 100%;
    		.line {
    			position: absolute;
    			left: 0;
    			height: 1px;
    			width: 100%;
    			background: rgba(#007AA4, 0.1);
    			&.one {
    				bottom: 0;
    			}
    			&.two {
					bottom: 25%;
    			}
    			&.three {
    				bottom: 50%;
    			}
    			&.four {
    				bottom: 75%;
    			}
    			&.five {
    				bottom: 100%;
    			}
    		}
    	}
	}
</style>
